import { Col, Row } from 'antd';
import { employeeApi } from 'Api/employee';
import { Loader } from 'components/Global';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useSearchParams } from 'react-router-dom';
import styles from './index.module.scss';
import Ellipse from 'components/Global/Ellipse';

const EarningsModal: React.FC<any> = ({
	activeTab,
	setEarningsAmount,
	isUSD,
	setIsLoading,
	isLoading,
}) => {
	const [data, setData] = useState<any>([]);
	const [searchParams] = useSearchParams();

	const { baseCurrencySymbol, usdCurrencySymbol } = useSelector(
		(state: any) => state.userProfile.data
	);

	const fetchEmployeeEarnings = async () => {
		setIsLoading(true);
		try {
			const apiData = await employeeApi.getEmployeeMasterEarnings({
				employeeId: searchParams.get('employeeId'),
			});

			const responseData = apiData?.data?.data || [];
			const isPayrollRun = apiData?.data?.isPayrollRun;

			let finalData = isPayrollRun
				? responseData
				: responseData.filter((item: any) => item.isChecked);

			setData(finalData);
			const total = finalData?.reduce(
				(sum: number, item: any) =>
					sum + parseFloat(item?.amount || '0.00'),
				0
			);
			setEarningsAmount(total);
		} catch (error: any) {
			console.error('Error fetching earnings:', error);
		} finally {
			setIsLoading(false);
		}
	};

	useEffect(() => {
		if (activeTab === 'earnings') {
			fetchEmployeeEarnings();
		}
	}, [activeTab]);

	return (
		<>
			{isLoading ? (
				<div
					style={{
						display: 'flex',
						justifyContent: 'center',
						alignItems: 'center',
						height: '50vh',
					}}
				>
					<Loader />
				</div>
			) : (
				<div className={styles.earningsContainer}>
					<Row gutter={16}>
						{data.map((item: any) => (
							<Col
								key={item.id || item.description}
								span={12}
								className={styles.earningsItem}
							>
								<div className={styles.earningsContent}>
									<div className={styles.labelContainer}>
										<Ellipse
											maxLength={20}
											message={item?.description}
											isTooltip={true}
											tooltipMessage={item?.description}
											key={item?.description}
										/>
									</div>
									<span className={styles.colon}>:</span>
									{/* :{' '} */}
									<div className={styles.amount}>
										{item.amount}{' '}
										{isUSD
											? usdCurrencySymbol
											: baseCurrencySymbol}
									</div>
								</div>
							</Col>
						))}
					</Row>
				</div>
			)}
		</>
	);
};

export default EarningsModal;
